import * as React from 'react';

import { ContactButtons } from '../../components/ContactButtons';
import { trackShowPhone } from '../../services';
import { Call } from '../Call';
import { CallbackButtonContainer } from '../CallbackButton';

interface IContactButtonsContainerProps {
  hasPoster: boolean;
}

export function ContactButtonsContainer({ hasPoster }: IContactButtonsContainerProps) {
  return (
    <ContactButtons
      callButton={<Call onShowPhone={trackShowPhone('Open_card_builder_contact_block')} />}
      callbackButton={
        <CallbackButtonContainer
          fullWidth={true}
          theme={hasPoster ? 'fill_primary' : 'fill_secondary'}
          place="headblock"
        />
      }
    />
  );
}
